import { iframeTemplates } from 'conversional-iframe-communication';
import { Result, Idle, Entry, ExitIntent, ExitIntentMobile, TrustPulse, Inline, Launcher, Dynamic, Preview, Arbitrary, Preloader, } from '../views';
var DEFAULT_PAGE = 'IDLE';
export default function getView(pageName) {
    var _a;
    if (pageName === void 0) { pageName = DEFAULT_PAGE; }
    var pageMap = (_a = {},
        _a[DEFAULT_PAGE] = Idle,
        _a[iframeTemplates.ENTRY] = Entry,
        _a[iframeTemplates.LAUNCHER] = Launcher,
        _a[iframeTemplates.RESULT] = Result,
        _a[iframeTemplates.EXIT_INTENT] = ExitIntent,
        _a[iframeTemplates.EXIT_INTENT_MOBILE] = ExitIntentMobile,
        _a[iframeTemplates.TRUST_PULSE] = TrustPulse,
        _a[iframeTemplates.INLINE] = Inline,
        _a[iframeTemplates.DYNAMIC] = Dynamic,
        _a[iframeTemplates.PREVIEW] = Preview,
        _a[iframeTemplates.ARBITRARY] = Arbitrary,
        _a[iframeTemplates.PRELOADER] = Preloader,
        _a);
    return pageMap[pageName] || pageMap[DEFAULT_PAGE];
}
